import { useNavigate, useLocation } from 'react-router-dom';

function roleLabel(role) {
  const labels = {
    super_admin: 'Super Administrateur',
    admin: 'Administrateur',
    responsable_facturation: 'Responsable Facturation',
    agent_facturation: 'Agent Facturation',
    prepose: 'Préposé Abattoir',
    responsable_preposes: 'Responsable Préposés',
    caissier: 'Caissier',
    caissier_principal: 'Caissier Principal',
    comptable: 'Comptable',
    verificateur: 'Vérificateur',
    service_achats: 'Service Achats',
    maintenance: 'Maintenance',
    controle_gestion: 'Contrôle de Gestion',
    direction: 'Direction',
    comptabilite: 'Comptabilité',
  };
  return labels[role] || role;
}

export default function Header({ utilisateur, onDeconnexion, onMotDePasse }) {
  const navigate = useNavigate();
  const location = useLocation();
  const pagesRacines = ['/', '/dashboard', '/login'];
  const afficherRetour = !pagesRacines.includes(location.pathname);

  return (
    <>
      <div style={{
        backgroundColor: '#1a5c2a',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}>
        <img src="/logo-sogas.png" alt="SOGAS" style={{ height: 55, objectFit: 'contain' }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ color: 'white', textAlign: 'right' }}>
            <div style={{ fontWeight: 'bold', fontSize: 15 }}>
              👤 {utilisateur?.prenom} {utilisateur?.nom}
            </div>
            <div style={{ fontSize: 12, opacity: 0.8 }}>
              {roleLabel(utilisateur?.role)}{utilisateur?.abattoir_nom ? ` — ${utilisateur.abattoir_nom}` : ' — Tous les abattoirs'}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {onMotDePasse && (
              <button onClick={onMotDePasse} style={{
                backgroundColor: 'transparent',
                color: '#fff',
                border: '1px solid rgba(255,255,255,0.5)',
                padding: '8px 14px',
                borderRadius: 6,
                cursor: 'pointer',
                fontSize: 13,
              }}>🔒 Mot de passe</button>
            )}
            <button onClick={onDeconnexion} style={{
              backgroundColor: '#c0392b',
              color: '#fff',
              border: 'none',
              padding: '8px 16px',
              borderRadius: 6,
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: 13,
            }}>Déconnexion</button>
          </div>
        </div>
      </div>

      {afficherRetour && (
        <div style={{ padding: '8px 24px' }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              background: '#f5f5f5',
              border: '1px solid #ddd',
              borderRadius: '6px',
              color: '#444',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '500',
              padding: '6px 14px',
            }}
          >
            ‹ Retour
          </button>
        </div>
      )}
    </>
  );
}
